import styled from 'styled-components'

import type { SvgProps } from './types'

export const Svg = styled.svg<SvgProps>`
  color: ${({ theme, color }) => color || theme.colors.white};

  circle#rail {
    fill: transparent;
    stroke: ${({ theme, bgColor }) => bgColor || theme.colors.slateGray};
    stroke-linecap: round;
  }
  circle#train {
    fill: transparent;
    stroke: currentColor;
    stroke-linecap: round;

    transform: rotate(-90deg);
    stroke-dasharray: ${({ width }) => 3.14 * width};
    transform-origin: ${({ width }) => `${width / 2}px ${width / 2}px 0`};

    animation: spinner 1.5s ease-in infinite;
  }

  @keyframes spinner {
    0% {
      stroke-dashoffset: ${({ width }) => 3.14 * width};
    }
    50% {
      stroke-dashoffset: 0;
    }
    100% {
      stroke-dashoffset: ${({ width }) => -3.14 * width};
    }
  }
`
